import React, { useState, useCallback, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDropzone } from "react-dropzone";
import cuid from "cuid";
import moment from "moment";
import { DatePicker } from "antd";
import { useSelector } from "react-redux";
import TextAreaField from "../../Shared/TextAreaField";
import DropDownField from "../../Shared/DropdownField";
import { POPUP_FILTERS } from "../../constants/PopupFilters";
import { DisplayMsg } from "../../services/toastService";
import { keyRestrict } from "../../utils/array";
import { setUrl } from "../../handlers";
import ComboBoxDropdownField from "../../Shared/ComboBoxDropdownField";

const NewTask = (props) => {
  const dropDownList = useSelector((state) => state.DropdownList);
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const [myFiles, setMyFiles] = useState([]);
  const [commentFiles, setCommentFiles] = useState([]);
  const [TaskInfo, setTaskInfo] = useState({ attachments: null });
  const [detailErr, setDetailErr] = useState(false);
  const [boxes, setBoxes] = useState({ select: false });

  useEffect(() => {
    const keyUpHandler = (event) => {
      if (event.target.name === "targetDate") {
        if (event.srcElement.value.length <= 10) {
          if (event.srcElement.value === "") {
            setTaskInfo((taskData) => ({
              ...taskData,
              targetDate: null,
            }));
          } else {
            setTaskInfo((taskData) => ({
              ...taskData,
              targetDate: event.srcElement.value,
            }));
          }
        } else {
          const updatedDate = event.srcElement.value.slice(0, 10);
          setTaskInfo((taskData) => ({
            ...taskData,
            targetDate: updatedDate,
          }));
        }
      }
    };

    document.addEventListener("keyup", keyUpHandler);

    return () => {
      document.removeEventListener("keyup", keyUpHandler);
    };
  }, [props]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      let check = true;
      check = CheckFileSize(acceptedFiles);
      if (check) {
        setCommentFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
        acceptedFiles.map((file) => {
          const reader = new FileReader();
          reader.onload = function (e) {
            setMyFiles((prevState) => [
              ...prevState,
              {
                id: cuid(),
                src: e.target.result,
                fileType: file.type,
                fileName: file.name,
              },
            ]);
          };
          reader.readAsDataURL(file);
          return file;
        });
      }
    },
    [myFiles]
  );

  const IsFileSizeValid = (file) => {
    const MaxFileSize = 30000;
    if (file && MaxFileSize) {
      const filesizeMb = (file.size / (1024 * 1024)).toFixed(2);
      return Math.round(parseFloat(filesizeMb)) <= parseInt(MaxFileSize);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: !boxes.select ? onDrop : undefined,
  });

  const Image = ({ file }) => {
    if (file.fileType.includes("image")) {
      return (
        <div className="file-item">
          <img alt={`img - ${file.id}`} src={file.src} className="d-block" />
        </div>
      );
    }
    return <p>{file.fileName}</p>;
  };

  const files = myFiles.map((currentFile) => (
    <div>
      <Image file={currentFile} key={`${currentFile.id}-image`} />
      <FontAwesomeIcon
        onClick={(e) => removeFile(currentFile)}
        icon="trash"
        color="red"
        size="lg"
      />
    </div>
  ));

  const removeFile = (file) => {
    const newFiles = [...myFiles];
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
  };

  const CreateTask = async () => {
    try {
      if (TaskInfo.taskDetail != null && TaskInfo.taskDetail != "") {
        document.getElementById("loader").style.display = "block";
        const jsonData = {
          txtTaskDetail: TaskInfo.taskDetail,
          txtNewTaskDueDate: isNaN(TaskInfo.targetDate)
            ? ""
            : moment(TaskInfo.targetDate).format("MM/DD/yyyy"),
          ddlNewTaskAssignee: TaskInfo.assignee,
          ddlNewTaskTeam: TaskInfo.teamValue,
          ddlNewTaskTeam_text: TaskInfo.teamName,
          ddlNewTaskType: TaskInfo.type,
          ddlNewTaskPriority: TaskInfo.priority,
        };
        const formData = new FormData();

        if (commentFiles.length > 0) {
          for (let i = 0; i < commentFiles.length; i++) {
            formData.append(`ImageFile${i}`, commentFiles[i]);
          }
        }

        formData.append(
          "TeamEmail",
          TaskInfo.teamEmail ? TaskInfo.teamEmail : ""
        );
        formData.append("jsonData", JSON.stringify(jsonData));
        formData.append("reporter", sessionStorage.USER);
        formData.append("entitySeqNum", sharedData.currentClientId);

        const response = await fetch(setUrl("TASK", "SAVE", true), {
          method: "POST",
          body: formData,
        });
        const json = await response.json();

        if (json.status) {
          TaskPopup(true);
          DisplayMsg("1", json.Message);
        } else {
          DisplayMsg("2", json.Message);
        }
      } else {
        setDetailErr(true);
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const TaskPopup = (check) => {
    props.parentCallback(check, "task");
  };

  const FieldValue = (fieldName) => {
    const fieldValue = TaskInfo[fieldName] != null ? TaskInfo[fieldName] : "";
    return fieldValue;
  };

  const CheckFileSize = (fileArray) => {
    for (let i = 0; i < fileArray.length; i++) {
      if (!IsFileSizeValid(fileArray[i])) {
        DisplayMsg(
          "2",
          `File[${fileArray[0].name}] size exceeds the allowed limit`
        );
        return false;
      }
    }
    return true;
  };

  const FieldData = (textField, type) => {
    const curName = textField.fieldName;
    const curValue = textField.fieldValue;

    if (type === "attachments") {
      let check = true;
      check = CheckFileSize(textField.target.files);
      if (check) {
        setTaskInfo((prevData) => ({
          ...prevData,
          attachments: textField.target.files,
        }));
      }
    } else if (curName === "teams") {
      dropDownList.TeamsList.forEach((team) => {
        if (team.value.toString() === curValue) {
          setTaskInfo((taskData) => ({
            ...taskData,
            teamValue: team.value,
            teamName: team.label,
            teamEmail: team.email,
          }));
        }
      });
    } else {
      setTaskInfo((prevInfo) => ({
        ...prevInfo,
        [curName]: curValue,
      }));
    }

    if (curName === "taskDetail") {
      if (curValue.length < 1) {
        setDetailErr(true);
      } else {
        setDetailErr(false);
      }
    }
  };

  const AlterTaskData = (dateVal, name) => {
    if (dateVal != null) {
      setTaskInfo((prevInfo) => ({
        ...prevInfo,
        [name]: new Date(dateVal),
      }));
    } else {
      setTaskInfo((prevInfo) => ({
        ...prevInfo,
        [name]: null,
      }));
    }
  };

  return (
    <>
      <div className="errorMsgPanel" />
      <div className="successMsgPanel" />

      <div id="popup4" className="overlay">
        <div className="popup">
          <div className="popup__header">
            <h3>New Task</h3>
            <span
              className="close"
              role="button"
              onClick={() => TaskPopup(true)}
              style={{
                cursor: "pointer",
              }}
            >
              ×
            </span>
          </div>

          <div className="content">
            <div className="popup__body">
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <TextAreaField
                    bold
                    id="taskDetail"
                    width
                    labelClass="field-placeholder label-top-text"
                    label="Task Detail:"
                    redMark
                    rows={9}
                    cols={20}
                    length={2000}
                    value={FieldValue("taskDetail")}
                    ReceivedTextData={FieldData}
                    requiredMsg={detailErr}
                  />
                </div>

                <div className="col-md-6 col-sm-6">
                  <div className="field-container overflow-visible">
                    <label className="field-placeholder">Target Date:</label>

                    <DatePicker
                      selected={
                        TaskInfo.targetDate ? TaskInfo.targetDate : null
                      }
                      onChange={(date) => AlterTaskData(date, "targetDate")}
                      className="field-input"
                      format="MM/DD/YYYY"
                      placeholder="MM/DD/YYYY"
                      maxDate={new Date(2099, 12, 12)}
                      onKeyDown={(e) => {
                        keyRestrict(e, "0123456789");
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="field-container">
                    <ComboBoxDropdownField
                      id="assignee"
                      bold
                      classDiv
                      label="Assignee:"
                      required={false}
                      options={dropDownList.AssigneeList}
                      value={FieldValue("assignee")}
                      ReceivedTextData={FieldData}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <DropDownField
                    id="teams"
                    bold
                    classDiv
                    label="Team:"
                    required={false}
                    options={dropDownList.TeamsList}
                    value={FieldValue("teamValue")}
                    ReceivedTextData={FieldData}
                  />
                </div>
                <div className="col-md-6 col-sm-6">
                  <DropDownField
                    id="type"
                    bold
                    classDiv
                    label="Type:"
                    required={false}
                    options={POPUP_FILTERS.TASK_TYPE_OPTIONS}
                    value={FieldValue("type")}
                    ReceivedTextData={FieldData}
                  />
                </div>
                <div className="col-md-6 col-sm-6">
                  <DropDownField
                    id="priority"
                    bold
                    classDiv
                    label="Priority:"
                    required={false}
                    options={POPUP_FILTERS.PRIORITY_OPTIONS}
                    value={FieldValue("priority")}
                    ReceivedTextData={FieldData}
                  />
                </div>
              </div>

              <div>
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <section className="mt-2">
                      <div
                        {...getRootProps({ className: "dropzone uploadInput" })}
                      >
                        <div className="dragDrop">
                          <div className="inside">
                            <input {...getInputProps()} />
                            <span className="dropzone-content">
                              <span>Drop files here</span>
                            </span>
                            <span className="ml-2">
                              <FontAwesomeIcon
                                icon="upload"
                                color="black"
                                size="sm"
                              />
                              File Upload
                            </span>
                          </div>
                        </div>
                      </div>
                      {files.length > 0 && (
                        <div className="file-list rounded mt-3">{files}</div>
                      )}
                    </section>
                  </div>
                </div>
                <span
                  style={{ color: "red" }}
                  id="CommentDetail_spanFileMaxLength"
                >
                  File size must not exceed 30 MB
                </span>
              </div>

              <div className="row-form">
                <div />
              </div>
              <div className="row text-center">
                <div className="col-md-12 col-sm-12">
                  <label>&nbsp;</label>
                  <input
                    type="button"
                    className="btnLinkGreen ClosePopup"
                    onClick={() => CreateTask()}
                    value="Create Task"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewTask;
